

export default class FilterFwg {
	static install(Vue, options) {
		Vue.filter('fwgpricecent', function (value, mode = "long") {
			let prefix = ""
			if (mode == "long") {
				prefix = "CHF "
			}
			else if (mode == "html") {
				prefix = "CHF&nbsp;"
			}
			
			let v = value / 100
			v = v || 0
			return prefix + v.toFixed(2)
		})
		Vue.filter('fwgcmstext', function (value) {
			let type = typeof value
			if (type == "string") {
				return value
					.replace(/(\r\n|\n)/g, "<br>")
			} else if (type == "number") {
				return value.toString()
			}
			return ""
		})
	}
}
